// extracted by mini-css-extract-plugin
export default {"chevronRow":"ChevronIndicators_chevronRow__b4LdU","chevron":"ChevronIndicators_chevron__Ujgs0"};